import { render, staticRenderFns } from "./AccountStrengthStar.vue?vue&type=template&id=aba01652&"
import script from "./AccountStrengthStar.vue?vue&type=script&lang=js&"
export * from "./AccountStrengthStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports